export default "__VITE_ASSET__DrzsxNch__"